import React, { useContext, useEffect, useState } from "react";
import { UiInput } from "../../_uiMocks/components/form/UiInput";
import MessageArrow from "../../../styles/img/svg/MessageSubmitArrow";
import UiChatBotFaq from "./UiChatBotFaq";
import UiChatYou from "./UiChatYou";
import UiChatSherBot from "./UiChatSherBot";
import UiChatBotZeroState from "./UiChatBotZeroState";
import { async } from "regenerator-runtime";
import { useDispatch, useSelector } from "react-redux";
import {
    homeCampaignListRequest,
    homeChatbotReplyQuestionComplete,
    homeChatbotReplyQuestionRequest,
    homeGetChatbotFaqQuestionsRequest,
} from "../../../_redux/_actions";
import { showCustomLoading } from "../../../_helpers/support.services";
import { UiChatBotLoadingSpinner } from "../common/UiLoadingSpinner";
import {
    participantJobRoleIds,
    participantTypeIds,
    homeConstants,
} from "../../../_redux/_constants";

export default function UiChatBot(props) {
    const [messageList, setMessageList] = useState([]);
    const [loaderTrigger, setLoaderTrigger] = useState(false);

    const actionDispatch = useDispatch();

    const { home, userProfileDetails, loader } = useSelector((state) => {
        return {
            home: state.home,
            userProfileDetails: state.auth.userProfileDetails,
            loader: state.loading,
        };
    });

    const faqs = home.faqList;
    const sendText = () => {
        let msgTxt = document.getElementById("messageBox").value;

        // setLoaderTrigger(true);

        actionDispatch(
            homeChatbotReplyQuestionRequest({
                messageType: "chatGpt",
                sender: "user",
                message: msgTxt,
            }),
        );
        document.getElementById("messageBox").value = "";
    };

    const faqSendText = (id, questionText) => {
        // setLoaderTrigger(true);

        actionDispatch(
            homeChatbotReplyQuestionRequest({
                messageType: "systemDefined",
                systemDefinedQueryTypeId: id,
                sender: "user",
                message: questionText,
            }),
        );

        document.getElementById("messageBox").value = "";
    };

    useEffect(() => {
        setMessageList(home.chatMessageList);
        // const messages = document.querySelector("#result");
        // messages.scrollTop = messages.scrollHeight;
    }, [home]);

    return (
        <>
            {showCustomLoading(
                [homeConstants.HOME_CHATBOT_REPLY_QUESTION_REQUEST],
                loader.pendingRequests,
            ) && <UiChatBotLoadingSpinner />}

            <div className="sb-chat-bot-box">
                <div className="sb-chat-bot-box__body">
                    <iframe
                        src="http://74.177.203.149:8080/?key=13GIAQLq3icHqAqF0CzoE1sxKSyD9WUi"
                        style={{
                            width: "100%",
                            height: "400px",

                            padding: 0,
                        }}
                    ></iframe>
                    {/* <h3>Need help? Ask me anything...</h3>
                    <div className="sb-chat-bot-box__content">
                        <div className="sb-chat-bot-box__left-col">
                            <div className="sb-chat-bot-box__left-col-content">
                                {faqs.map((list, index) => (
                                    <UiChatBotFaq
                                        onClick={faqSendText}
                                        item={list.questionText}
                                        key={list.id}
                                    />
                                ))}
                            </div>
                        </div>
                        <div className="sb-chat-bot-box__right-col">
                            <div
                                className="sb-chat-bot-box__result-area"
                                id="result"
                            >
                                

                                {messageList.map((e, index) => {
                                    return (
                                        <span key={index}>
                                            {e.sender == "chatBot" ? (
                                                <UiChatSherBot
                                                    chatLine={e.message}
                                                />
                                            ) : (
                                                <UiChatYou
                                                    chatLine={e.message}
                                                />
                                            )}
                                        </span>
                                    );
                                })}
                            </div>
                            <div className="sb-chat-bot-box__input-area">
                                <div className="sb-chat-box-input-area">
                                    <UiInput
                                        id="messageBox"
                                        placeholder="Message sherbot"
                                    />
                                    <span
                                        onClick={() => {
                                            sendText();
                                        }}
                                    >
                                        <MessageArrow />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
            {/* 
            {userProfileDetails.roleId == participantTypeIds.PARTICIPANT ? (
                <div className="sb-chat-box-support-mail-content">
                    If you need more help, please drop an email to:{" "}
                    <span>support@rgequipe.com</span>
                </div>
            ) : (
                <div className="sb-chat-box-support-mail-content">
                    If you need more help, please drop an email to:{" "}
                    <span>support@renaultTLC.com</span>
                </div>
            )} */}
        </>
    );
}
